"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuProvider = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const compound_components_1 = require("@clds/compound-components");
const childData_1 = require("./childData");
const MenuProvider = ({ children, registry, select, focusedId, selectedId, }) => (react_1.default.createElement(childData_1.ChildDataRegistryProvider, { value: registry },
    react_1.default.createElement(compound_components_1.ListSelectionProvider, { onClick: select, focusedId: focusedId, selectedId: selectedId }, children)));
exports.MenuProvider = MenuProvider;
//# sourceMappingURL=MenuProvider.js.map